import { render } from "./ScrollUp.vue?vue&type=template&id=877f8328&scoped=true"
import script from "./ScrollUp.vue?vue&type=script&lang=js"
export * from "./ScrollUp.vue?vue&type=script&lang=js"

import "./ScrollUp.vue?vue&type=style&index=0&id=877f8328&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-877f8328"]])

export default __exports__